/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ApprovalRequestSearchCriteria} from '../models/ApprovalRequestSearchCriteria';
import type {ApprovalRequestSearchResult} from '../models/ApprovalRequestSearchResult';
import type {Error} from '../models/Error';

export interface SearchApprovalRequests$Request {
    approvalRequestSearchCriteria: ApprovalRequestSearchCriteria;
}

export interface SearchApprovalRequests$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchApprovalRequestsRequest = createAction<PayloadData<void, SearchApprovalRequests$Request>>('REQUEST_SEARCH__SEARCH_APPROVAL_REQUESTS__REQUEST');
export const searchApprovalRequestsSuccess = createAction<PayloadData<ApprovalRequestSearchResult, SearchApprovalRequests$Request>>('REQUEST_SEARCH__SEARCH_APPROVAL_REQUESTS__SUCCESS');
export const searchApprovalRequestsFailure = createAction<PayloadData<Error, SearchApprovalRequests$Request, true>>('REQUEST_SEARCH__SEARCH_APPROVAL_REQUESTS__FAILURE');

export const searchApprovalRequestsActions = [
    searchApprovalRequestsRequest,
    searchApprovalRequestsSuccess,
    searchApprovalRequestsFailure
] as const;

/**
 * Search approval requests with filters and pagination.
 * @param {ApprovalRequestSearchCriteria} meta.approvalRequestSearchCriteria
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchApprovalRequests = (meta: SearchApprovalRequests$Request, config?: SearchApprovalRequests$Config) => {
    return {
        CALL_API: {
            types: searchApprovalRequestsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/approval/requests/search`,
            TRANSPORT_REQUEST_BODY: meta.approvalRequestSearchCriteria,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

